function showMessage(message) {
  let container = document.getElementById("messages");
  removeChildElements(container);
  let div = document.createElement("div");
  div.classList.add("alert");
  div.classList.add("alert-danger");
  div.innerHTML = humanize(message);
  container.appendChild(div);
}

let messages = {
  de: {
    not_allowed_error: "Der Vorgang wurde entweder abgebrochen oder war nicht erlaubt"
  },
  en: {
    not_allowed_error: "The operation either timed out or was not allowed"
  },
}

function humanize(message) {
  console.dir(message);
  if (message.name == "NotAllowedError") {
    return messages[window.locale].not_allowed_error;
  } else if (message[1] ==  "Internal Server Error") {
    return "Anwendungsfehler! Bitte versuchen Sie es später wieder."
  } else if (message ==  "Sorry, something wrong happened.") {
    return "Anwendungsfehler! Bitte versuchen Sie es später wieder."
  } else {
    return (message.message || message);
  }
}

function removeChildElements(elem) {
  var child = elem.lastChild;
  if (!child) return;

  elem.removeChild(child);
  removeChildElements(elem);
}

export { showMessage }
